import { render, staticRenderFns } from "./PDPPricingSticky.vue?vue&type=template&id=4e0520a4&scoped=true&"
import script from "./PDPPricingSticky.vue?vue&type=script&lang=js&"
export * from "./PDPPricingSticky.vue?vue&type=script&lang=js&"
import style0 from "./PDPPricingSticky.vue?vue&type=style&index=0&id=4e0520a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0520a4",
  null
  
)

export default component.exports